const rawSubdomainsMap = process.env['REACT_APP_SUBDOMAIN_MAP'] || "";

const subdomainsMap = rawSubdomainsMap.split(',').reduce((prev, curr) => {
  const [key, value] = curr.split(':');
  if (key && value) {
    prev.set(key, value);
  }
  return prev;
}, new Map<string, string>());


export default function getClientName() {
  const subdomain = window.location.hostname.split('.')[0];

  return subdomainsMap.get(subdomain) || subdomain;
}